<template>
  <a-modal
    title="添加招呼消息"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
    :destroyOnClose="true"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="消息类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['type', {initialValue: formData.type, rules: [{required: true, message: '必填项'}]}]"
          >
            <a-select-option value="1">文本</a-select-option>
            <a-select-option value="2">图片</a-select-option>
            <a-select-option value="3">视频</a-select-option>
            <a-select-option value="4">动图</a-select-option>
            <a-select-option value="5">卡片</a-select-option>
          </a-select>
        </a-form-item>
        <div v-if="formData['type'] == '1'">
          <a-form-item label="回复文本" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea placeholder="请输入" :rows="4" v-decorator="['wenben']"/>
          </a-form-item>
        </div>
        <div v-if="formData['type'] == '2'">
          <a-form-item label="回复图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div>
              <a-upload
                action="https://upload-z2.qiniup.com"
                listType="picture"
                class="upload-list-inline"
                :data="{'token': UploadToken}"
                :beforeUpload="beforeUpload"
                v-decorator="['tupian', {
                    valuePropName: 'fileList',
                    getValueFromEvent: normFile
                }]"
              >
                  <a-button v-if="formData['tupian'].length < 1">
                    <a-icon type="upload"/>上传
                  </a-button>
              </a-upload>
            </div>
          </a-form-item>
        </div>
        <div v-if="formData['type'] == '3'">
          <a-form-item label="回复视频" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div>
              <a-upload
                action="https://upload-z2.qiniup.com"
                listType="text"
                class="upload-list-inline"
                :data="{'token': UploadToken}"
                :beforeUpload="beforeUpload"
                v-decorator="['shipin', {
                    valuePropName: 'fileList',
                    getValueFromEvent: normFile
                }]"
              >
                <a-button v-if="formData['shipin'].length < 1">
                  <a-icon type="upload"/>上传
                </a-button>
              </a-upload>
            </div>
          </a-form-item>
        </div>
        <div v-if="formData['type'] == '4'">
          <a-form-item label="回复动图" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div>
              <a-upload
                action="https://upload-z2.qiniup.com"
                listType="picture"
                class="upload-list-inline"
                :data="{'token': UploadToken}"
                :beforeUpload="beforeUpload"
                v-decorator="['dongtu', {
                    valuePropName: 'fileList',
                    getValueFromEvent: normFile
                }]"
              >
                <a-button v-if="formData['dongtu'].length < 1">
                  <a-icon type="upload"/>上传
                </a-button>
              </a-upload>
            </div>
          </a-form-item>
        </div>
        <div v-show="formData['type'] == '5'">
          <a-form-item label="卡片标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" :rows="4" v-decorator="['kapianTitle']" />
          </a-form-item>
          <a-form-item label="卡片描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" :rows="4" v-decorator="['kapianDesc']" />
          </a-form-item>
          <a-form-item label="卡片图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" :rows="4" v-decorator="['kapianImg']" />
          </a-form-item>
          <a-form-item label="卡片链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input placeholder="请输入" :rows="4" v-decorator="['kapianUrl']" />
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>
<script>
import ProgramApi from '@/api/program'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this, {
        onValuesChange: (_, values) => {
          Object.assign(this.formData, values)
        }
      }),
      formData: {
        type: '1',
        tupian: [],
        shipin: [],
        dongtu: []
      },
      UploadToken: ''
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const id = Math.random().toString(36).substr(2)
          const type = values.type
          let content = ''
          if (type == '1') {
            content = values.wenben
          } else if (type == '2') {
            if(!values.tupian[0]){
              this.$message.error('必须上传一个图片')
              return false
            }
            content = JSON.stringify(values.tupian[0].response)
          } else if (type == '3') {
            if(!values.shipin[0]){
              this.$message.error('必须上传一个视频')
              return false
            }
            content = JSON.stringify(values.shipin[0].response)
          } else if (type == '4') {
            if(!values.dongtu[0]){
              this.$message.error('必须上传一个动图')
              return false
            }
            content = JSON.stringify(values.dongtu[0].response)
          }else if (type == '5') {
            content = JSON.stringify({
              title:values.kapianTitle,
              des:values.kapianDesc,
              img:values.kapianImg,
              url:values.kapianUrl,
            })
          }
          if(!content){
            this.$message.error('回复内容为空或正在上传文件')
            return false
          }
          this.$emit('ok',{id, type, content})
          this.form.resetFields()
          this.form.setFieldsValue({
            type: '1'
          })
          this.formData = {
            type: '1',
            tupian: [],
            shipin: [],
            dongtu: [],
          }
          this.visible = false
        }
      })
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e
      }
      return e && e.fileList
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('由于微信限制，上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then(response => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(()=>{
                resolve()
              },100)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    beforeUploadImg(file) {
      return new Promise((resolve, reject) => {
        const isLt25M = file.size / 1024 / 1024 < 25
        if (!isLt25M) {
          this.$message.error('由于微信限制，上传文件不能大于25M!')
          reject()
        }
        ProgramApi.getQiniuToken()
          .then(response => {
            if (response.code === 1) {
              const token = response.data
              this.UploadToken = token
              setTimeout(()=>{
                resolve()
              },100)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
</script>
<style scoped>
/* tile uploaded pictures */
.upload-list-inline >>> .ant-upload-list-item {
  float: left;
  width: 100%;
  margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}
</style>
